export const LIMIT_ITEMS_MEDIA = 36;
export const BASE_URL = 'http://pegatv.vn/';
//export const BASE_URL = 'http://pegatv.vn/';
export const BASE_URL_API = 'http://comment.vietidv2.net/apiv1';
export const SERVER_IP='http://api.pegatv.vn'



// WEBPACK FOOTER //
// ./src/constants/Common.js